const merge = require('lodash.merge')
const FronthubError = require('./helpers/FronthubError')

const isNull = o => o === null
const isError = e =>
  !!(e instanceof Error || (e && e.stack && typeof e.message === 'string'))
const throwError = (message, err = '') => {
  throw new FronthubError(`${message}\n\n${err}`)
}
const isPromise = p =>
  p instanceof Promise || (p && typeof p.then === 'function')
const isFunction = f => typeof f === 'function'
const isValid = o => !isNull(o)
const isObject = o =>
  !isNull(o) && typeof o === 'object' && o.constructor === Object

function mutate(target) {
  return function () {
    merge.call(void 0, [target, ...Array.from(arguments)])
  }
}

module.exports = {
  mutate,
  isPromise,
  isNull,
  isError,
  throwError,
  isFunction,
  isValid,
  isObject,
}
